export default {"src":"/_next/static/media/cargill.a105ba7b.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};